import { schema } from 'normalizr';

export const barber = new schema.Entity('barbers', {
  services: [
    new schema.Entity('services', {}, {
      idAttribute: (service, parent) => `${parent.id}.${service.id}`,
    }),
  ],
});
export const arrayOfBarbers = new schema.Array(barber);

export const brandBarberShopsDataForEdit = new schema.Entity('barberShopData', {

}, {
  idAttribute: 'shopId',
});
export const brandBarberForEdit = new schema.Array(brandBarberShopsDataForEdit);
